import { render, staticRenderFns } from "./StepperSeparator.vue?vue&type=template&id=45f31512&scoped=true&"
import script from "./StepperSeparator.vue?vue&type=script&lang=js&"
export * from "./StepperSeparator.vue?vue&type=script&lang=js&"
import style0 from "./StepperSeparator.vue?vue&type=style&index=0&id=45f31512&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f31512",
  null
  
)

export default component.exports